import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../../utils/formatting';
import React from 'react';
import { getTimeUnitText } from '../../../../utils';
import { UnreachableCaseError } from 'ts-essentials';
import DateDisplay from './DateDisplay';
import { IDatePickerFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { IStyled } from '../../../../styles/types';

interface IProps extends IStyled {
  datePicker: IDatePickerFieldsFragment;
  hideFixedDateRange?: boolean;
}

const DatePickerDisplay = ({
  datePicker,
  className,
  hideFixedDateRange,
}: IProps) => {
  const type = datePicker.__typename;
  if (type === 'DatePickerFixed') {
    return (
      <span className={className}>
        Fixed
        {!hideFixedDateRange && (
          <>
            {' '}
            <DateDisplay date={datePicker.start} /> -{' '}
            <DateDisplay date={datePicker.end} />
          </>
        )}
      </span>
    );
  } else if (type === 'DatePickerSince') {
    return (
      <span className={className}>
        Since <DateDisplay date={datePicker.start} />
      </span>
    );
  } else if (type === 'DatePickerStartOf') {
    return <>Start of {getTimeUnitText(datePicker.unit).singular}</>;
  } else if (type === 'DatePickerLast') {
    const timeUnitHuman = getTimeUnitText(datePicker.unit);
    return (
      <span className={className}>
        Last{' '}
        {globalFormat.formatNumber(
          datePicker.period,
          defaultNumberFormatOptions.integer,
        )}{' '}
        {datePicker.period === 1
          ? timeUnitHuman.singular
          : timeUnitHuman.plural}
      </span>
    );
  } else if (type === 'DatePickerLastFull') {
    const timeUnitHuman = getTimeUnitText(datePicker.unit);
    return (
      <span className={className}>
        Last full{' '}
        {globalFormat.formatNumber(
          datePicker.period,
          defaultNumberFormatOptions.integer,
        )}{' '}
        {datePicker.period === 1
          ? timeUnitHuman.singular
          : timeUnitHuman.plural}
      </span>
    );
  } else {
    throw new UnreachableCaseError(type);
  }
};

export default DatePickerDisplay;
